import axiosInstance from "../axiosInstance";

export const createUser = async (data) => {
  try {
    const response = await axiosInstance.post("/register", data);
    return response.data;
  } catch (error) {
    console.error("Error sending sign-up data", error);
    throw error;
  }
};

export const login = async (data) => {
  try {
    const response = await axiosInstance.post("/login", data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error sending sign-in data", error);
    throw error;
  }
};

export const refreshToken = async () => {
  try {
    const savedUser = localStorage.getItem("userData");
    if (!savedUser) return null;

    const parsedUser = JSON.parse(savedUser);

    if (!parsedUser.refreshToken) return null;

    const response = await axiosInstance.post(
      "/refresh_token",
      { refreshToken: parsedUser.refreshToken },
      { withCredentials: true },
    );

    const refreshedData = response.data;

    const updatedUserData = {
      ...parsedUser,
      token: refreshedData.token,
      refreshToken: refreshedData.refreshToken,
    };

    localStorage.setItem("userData", JSON.stringify(updatedUserData));

    return updatedUserData;
  } catch (error) {
    console.error("Error refreshing token", error);
    return null;
  }
};

export const forgotPassword = async (data) => {
  try {
    const response = await axiosInstance.post("/forgot_password", data);
    return response.data;
  } catch (error) {
    console.error("Error sending sign-up data", error);
    throw error;
  }
};

export const resetPassword = async (data, token) => {
  try {
    const response = await axiosInstance.post("/reset_password", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending reset password data", error);
    throw error;
  }
};

export const verify = async (data) => {
  try {
    const response = await axiosInstance.post("/verify", data);
    return response.data;
  } catch (error) {
    console.error("Error sending verify data", error);
    throw error;
  }
};

export const verifyForgetPassword = async (token) => {
  try {
    const response = await axiosInstance.post("/verify_forget", token);
    return response.data;
  } catch (error) {
    console.error("Error sending verify data", error);
    throw error;
  }
};

export const googleLogin = async (code) => {
  try {
    const response = await axiosInstance.post("/google-login", {
      code,
    });

    return response.data;
  } catch (error) {
    return {
      status: false,
      message: error?.response?.data?.message || "Google login failed",
    };
  }
};
